import BaseApi from './base'
import queryString from 'query-string'

export default class UserApi extends BaseApi {
  constructor(userId) {
    super()
    this.userId = userId
  }

  /**
   * Gets the public user name for the current, logged in user
   * @returns {Promise<AxiosResponse<T>>}
   */
  getPublicUsername() {
    return this.axios.get(`/users/get_public_username/`).then(({ data }) => {
      return data
    })
  }

  /**
   * Sets the public user name for the current, logged in user
   * @param {number|undefined} wordOne
   * @param {number|undefined} wordTwo
   * @param {number=} emojiId
   * @returns {Promise<AxiosResponse<T>>}
   */
  setPublicUsername(wordOne, wordTwo, emojiId) {
    let query = {}

    if (wordOne) {
      query['publicUsername[word_one]'] = wordOne
    }

    if (wordTwo) {
      query['publicUsername[word_two]'] = wordTwo
    }

    if (emojiId) {
      query['publicUsername[emoji]'] = emojiId
    }

    return this.axios
      .post(`/users/set_public_username/`, queryString.stringify(query))
      .then(({ data }) => {
        return data
      })
  }

  /**
   * Gets all the avilable options for current user to pick from
   * @returns {Promise<AxiosResponse<T>>}
   */
  getRandomUsernameWords() {
    return this.axios
      .get(`/users/get_public_username_options/`)
      .then(({ data }) => {
        return data['words']
      })
  }

  /**
   * Gets all the avilable options for current user to pick from
   * @returns {Promise<AxiosResponse<T>>}
   */
  getUsernameEmojis() {
    return this.axios
      .get(`/users/get_public_username_options/`)
      .then(({ data }) => {
        return data['emojis']
      })
  }
}
